import { useMemo } from 'react';
import Highcharts from 'highcharts';
import { makeArrayOfObjectOutOfMetricsData } from '../../../utils/transformChartsAndTableData';

export const useTranFormReviewRatingChartOption = (options, valueSuffix, selectedMetrix, data) => {
  return useMemo(() => {
    const jsonData = makeArrayOfObjectOutOfMetricsData(data)
    if (!options) return null;
    const extraConfig = {
      tooltip: {
        useHTML: true,
        outside: true,
        backgroundColor: 'transparent',
        borderWidth: 0,
        shadow: false,
        padding: 0,
        positioner: function (labelWidth, labelHeight, point) {
          const chart = this.chart;
          return {
            x: chart.plotLeft + chart.plotWidth / 2 - labelWidth / 2,
            y: point.plotY + chart.plotTop - labelHeight - 12
          };
        },
        formatter: function () {
          const value = Highcharts.numberFormat(this.y, 2);
          return `
           <div style="
             background: #1e222c;
             color: #fff;
             padding: 12px 18px;
             border-radius: 14px;
             font-size: 14px;
             box-shadow: 0 4px 14px rgba(0,0,0,0.25);
             display: flex;
             flex-direction: column;
             gap: 6px;
             pointer-events: none;
           ">
             <div style="font-size: 14px; font-weight: 600;">${this.key}</div>
             <div style="display: flex; align-items: center; justify-content: space-between;">
               <div style="display: flex; align-items: center; gap: 6px;">
                 <div style="
                   width: 10px; height: 10px;
                   background: ${this.color};
                 "></div>
                 <div>${selectedMetrix} &nbsp;&nbsp;&nbsp;&nbsp;</div>
               </div>
               <span style="font-weight: 600;">${value} ${valueSuffix}</span>
             </div>
           </div>
           <div style="
             width: 0; height: 0; margin: 0 auto;
             border-left: 10px solid transparent;
             border-right: 10px solid transparent;
             border-top: 12px solid #1e222c;
           "></div>
         `;
        }
      },
      plotOptions: {
        series: {
          dataLabels: {
            enabled: true,
            formatter: function () {
              return this.y != null ? this.y.toFixed(2) + valueSuffix : '0.00';
            }
          },

        }
      },
      xAxis: { categories: data?.rows },
      series: [
        { data: jsonData?.map(e => e?.[selectedMetrix]) || [] }
      ]
    };

    const mergedOptions = Highcharts.merge(options, extraConfig);

    return mergedOptions;
  }, [options, selectedMetrix]);
};
